import { Component, Prop } from "vue-property-decorator";
import SelectForm from "../../SelectForm";
import { InputOption, KeyValue } from "../../../../../../models/Input";
import { ParametreDto } from "../../../../../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { ParametresInstance } from "../../../../../../../components/Controls/Parameters";

@Component
export default class PaysSelectForm extends SelectForm {
	@Prop()
	public dataInputOption!: InputOption;

	public keyValue: KeyValue[] = [];

	private listePays: ParametreDto[] = [];

	private focusEvent(): void {

		if (this.listePays.length === 0) {
			this.listePays = ParametresInstance.listePays.sort((a, b) => a.Libelle!.localeCompare(b.Libelle!));

			for (let i = 0; i < this.listePays.length; i++) {
				this.keyValue.push({
					key: this.listePays[i].Code!,
					value: this.listePays[i].Libelle!
				});
			}
		}
	}

	public changed(): void {
		this.$emit("changed");
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/forms/extended/SelectForm/selects/PaysSelectForm/PaysSelectForm.ts